import React, { useMemo } from "react";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import ChoosePerson, {
  ChoosePersonOptionType,
} from "../shared/components/choose-person";
import { useMessageSource } from "react-message-source";
import { NaturalPersonDocument } from "../../api/commercial/generated-types";
import { COMPANY_AS_SELECTION } from "./types";

interface StatementRecipientProps {
  authorizedRepresentatives: NaturalPersonDocument[];
}

const COMPANY_OPTION: ChoosePersonOptionType = {
  id: "statementRecipientCompany",
  value: COMPANY_AS_SELECTION,
  messageKey: "CompanyOnline-statement-recipient.radio-company",
};

export const StatementRecipient: React.FC<StatementRecipientProps> = ({
  authorizedRepresentatives,
}: StatementRecipientProps) => {
  const { getMessage } = useMessageSource();

  const availableOptions: ChoosePersonOptionType[] = useMemo(
    () => [
      COMPANY_OPTION,
      ...authorizedRepresentatives.map((representative) => ({
        id: `statementRecipient-${representative.emailBusiness}`,
        value: representative.emailBusiness,
        messageKey: `${representative.firstName} ${representative.lastName}`,
      })),
    ],
    [authorizedRepresentatives],
  );

  return (
    <RadioButtonContainer>
      <ChoosePerson
        title={getMessage(
          "CompanyOnline-statement-cards-and-pin-delivery.radio-one",
        )}
        id="selectedStatementRecipient"
        name="selectedStatementRecipient"
        values={availableOptions}
      />
    </RadioButtonContainer>
  );
};
